import React, { useEffect, useState, createContext } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { HeroSection } from './components/HeroSection';
import { HowItWorksSection } from './components/HowItWorksSection';
import { BenefitsSection } from './components/BenefitsSection';
import { PricingSection } from './components/PricingSection';
import { FoundersNoteSection } from './components/FoundersNoteSection';
import { FAQSection } from './components/FAQSection';
import { TestimonialsSection } from './components/TestimonialsSection';
import { MoreThanLessonsSection } from './components/MoreThanLessonsSection';
import { VisionSection } from './components/VisionSection';
import { Navbar } from './components/Navbar';
import { Footer } from './components/Footer';
import { TeacherSignUp } from './components/pages/TeacherSignUp';
import { StudentSignUp } from './components/pages/StudentSignUp';
import { StudentLogin } from './components/pages/StudentLogin';
import { TeacherLogin } from './components/pages/TeacherLogin';
import { StudentDashboard } from './components/pages/StudentDashboard';
import { StudentMessages } from './components/pages/StudentMessages';
import { TeacherMessages } from './components/pages/TeacherMessages';
import { FindTeachers } from './components/pages/FindTeachers';
import { CompleteTeacherProfile } from './components/pages/CompleteTeacherProfile';
import { TeacherPublicProfile } from './components/pages/TeacherPublicProfile';
import { TeacherDashboard } from './components/pages/TeacherDashboard';
import { TeacherProfile } from './components/pages/TeacherProfile';
import { ReportsDashboard } from './components/pages/ReportsDashboard';
import { OnlineCourses } from './components/pages/OnlineCourses';
import { PublicCoursesPage } from './components/pages/PublicCoursesPage';
import { MyStudents } from './components/pages/MyStudents';
import { StudentSettings } from './components/pages/StudentSettings';
import { StudentSchedule } from './components/pages/StudentSchedule';
import { StudentProfilePage } from './components/pages/StudentProfilePage';
import { StudentGradesOverview } from './components/pages/StudentGradesOverview';
import { GradesManagementPage } from './components/pages/GradesManagementPage';
import { StudentDataCheck } from './components/pages/StudentDataCheck';
import { AuthProvider } from './contexts/AuthContext';
import { ScrollToTop } from './components/ScrollToTop';
import { SignInModal } from './components/SignInModal';
import { initEmailService } from './services/emailService';
import { EmailVerificationPage } from './components/pages/EmailVerificationPage';
import { InstrumentSelectionPage } from './components/pages/InstrumentSelectionPage';
import { TeacherMatchingPage } from './components/pages/TeacherMatchingPage';
import { SheetMusicPage } from './components/pages/SheetMusicPage';
import { MoonlightSonataViewer } from './components/pages/MoonlightSonataViewer';
import { PreludeInCMajorViewer } from './components/pages/PreludeInCMajorViewer';
import { GenericSheetMusicViewer } from './components/pages/GenericSheetMusicViewer';
import { TeacherTasks } from './components/pages/TeacherTasks';
import { StudentLayout } from './components/layouts/StudentLayout';
import { TeacherLayout } from './components/layouts/TeacherLayout';
import { RoleAwareLayout } from './components/layouts/RoleAwareLayout';
import { VirtualClassroom } from './components/pages/VirtualClassroom';
import { ToastContainer } from './components/ToastContainer';
import { PaymentMethodsPage } from './components/pages/PaymentMethodsPage';
import { TransactionHistoryPage } from './components/pages/TransactionHistoryPage';
import { SubscriptionManagementPage } from './components/pages/SubscriptionManagementPage';
import { Calendar2 } from './components/pages/Calendar2';
import { MyInfoPage } from './components/pages/MyInfoPage';
import { SettingsPage } from './components/pages/SettingsPage';
import { AccountSecurityPage } from './components/pages/AccountSecurityPage';
import { BillingPayoutsPage } from './components/pages/BillingPayoutsPage';
import { HelpSupportPage } from './components/pages/HelpSupportPage';
import { PayoutsInvoicesPage } from './components/pages/PayoutsInvoicesPage';
import { ThemeProvider, useTheme } from './components/providers/ThemeProvider';
import { ForgotPassword } from './components/pages/ForgotPassword';
import { TeacherEmailVerificationPage } from './components/pages/TeacherEmailVerificationPage';
import { VerifyEmailPage } from './components/pages/VerifyEmailPage';
import { Toaster } from 'react-hot-toast';
import { RevenuePage } from './components/pages/RevenuePage';
import { TeacherPublicProfilePage } from './components/pages/TeacherPublicProfilePage';
import { StudentSelfProfilePage } from './components/pages/StudentSelfProfilePage';
import { AboutUsPage } from './components/pages/AboutUsPage';
import { CareersPage } from './components/pages/CareersPage';
import { KnowledgeBaseGettingStarted } from './components/pages/KnowledgeBaseGettingStarted';
import { KnowledgeBaseSchedulingLessons } from './components/pages/KnowledgeBaseSchedulingLessons';
import { KnowledgeBaseVirtualClassroom } from './components/pages/KnowledgeBaseVirtualClassroom';
import { PrivacyPolicyPage } from './components/pages/PrivacyPolicyPage';
import { CookiePolicyPage } from './components/pages/CookiePolicyPage';
import { TermsOfServicePage } from './components/pages/TermsOfServicePage';
// Create a context for the sign in modal
export const SignInModalContext = createContext({
  isSignInModalOpen: false,
  openSignInModal: () => {},
  closeSignInModal: () => {}
});
// Create a wrapper component that uses the theme
function AppContent() {
  const {
    theme
  } = useTheme();
  // Initialize EmailJS when the app loads
  useEffect(() => {
    initEmailService();
  }, []);
  // Global state for sign in modal
  const [isSignInModalOpen, setIsSignInModalOpen] = useState(false);
  const openSignInModal = () => {
    setIsSignInModalOpen(true);
  };
  const closeSignInModal = () => {
    setIsSignInModalOpen(false);
  };
  return <AuthProvider data-id="element-0">
      <SignInModalContext.Provider value={{
      isSignInModalOpen,
      openSignInModal,
      closeSignInModal
    }} data-id="element-1">
        <div className="w-full min-h-screen bg-gradient-to-r from-[#0F1626] via-[#1E3A8A] to-[#2C3E50] text-white font-sans" data-id="element-2">
          <BrowserRouter data-id="element-3">
            <ScrollToTop data-id="element-4" />
            <Routes data-id="element-5">
              <Route path="/" element={<>
                    <Navbar data-id="element-7" />
                    <main data-id="element-8">
                      <HeroSection data-id="element-9" />
                      <HowItWorksSection data-id="element-10" />
                      <BenefitsSection data-id="element-11" />
                      <MoreThanLessonsSection data-id="element-12" />
                      <TestimonialsSection data-id="element-13" />
                      <FoundersNoteSection data-id="element-14" />
                      <VisionSection data-id="element-15" />
                      <PricingSection data-id="element-16" />
                      <FAQSection data-id="element-17" />
                    </main>
                    <Footer data-id="element-18" />
                  </>} data-id="element-6" />
              <Route path="/teacher-signup" element={<TeacherSignUp data-id="element-20" />} data-id="element-19" />
              <Route path="/student-signup" element={<StudentSignUp data-id="element-22" />} data-id="element-21" />
              <Route path="/student-login" element={<StudentLogin data-id="element-24" />} data-id="element-23" />
              <Route path="/teacher-login" element={<TeacherLogin data-id="element-26" />} data-id="element-25" />
              <Route path="/forgot-password" element={<ForgotPassword data-id="element-28" />} data-id="element-27" />
              {/* Email verification routes */}
              <Route path="/email-verification" element={<EmailVerificationPage data-id="element-30" />} data-id="element-29" />
              <Route path="/teacher-email-verification" element={<TeacherEmailVerificationPage data-id="element-32" />} data-id="element-31" />
              {/* New route for handling email verification links */}
              <Route path="/verify-email" element={<VerifyEmailPage data-id="element-34" />} data-id="element-33" />
              {/* Student routes with consistent sidebar */}
              <Route path="/student-dashboard" element={<StudentLayout data-id="element-36">
                    <StudentDashboard data-id="element-37" />
                  </StudentLayout>} data-id="element-35" />
              <Route path="/messages" element={<StudentLayout data-id="element-39">
                    <StudentMessages data-id="element-40" />
                  </StudentLayout>} data-id="element-38" />
              <Route path="/find-teachers" element={<StudentLayout data-id="element-42">
                    <FindTeachers data-id="element-43" />
                  </StudentLayout>} data-id="element-41" />
              <Route path="/online-courses" element={<StudentLayout data-id="element-45">
                    <OnlineCourses data-id="element-46" />
                  </StudentLayout>} data-id="element-44" />
              <Route path="/sheet-music" element={<StudentLayout data-id="element-48">
                    <SheetMusicPage data-id="element-49" />
                  </StudentLayout>} data-id="element-47" />
              <Route path="/student-settings" element={<StudentLayout data-id="element-51">
                    <StudentSettings data-id="element-52" />
                  </StudentLayout>} data-id="element-50" />
              {/* PHASE 2: Student self-profile route */}
              <Route path="/student/profile" element={<StudentLayout data-id="element-54">
                    <div className="min-h-screen flex items-center justify-center" data-id="element-55">
                      <p className="text-gray-500" data-id="element-56">Profile page coming soon</p>
                    </div>
                  </StudentLayout>} data-id="element-53" />
              <Route path="/my-profile" element={<StudentLayout data-id="element-58">
                    <div className="min-h-screen flex items-center justify-center" data-id="element-59">
                      <p className="text-gray-500" data-id="element-60">Profile page coming soon</p>
                    </div>
                  </StudentLayout>} data-id="element-57" />
              {/* Teacher routes - updated with new profile route */}
              <Route path="/teacher-dashboard" element={<TeacherDashboard data-id="element-62" />} data-id="element-61" />
              <Route path="/teacher-profile" element={<TeacherPublicProfilePage data-id="element-64" />} data-id="element-63" />
              {/* Teacher calendar routes - MUST come before /teacher/:id to avoid conflicts */}
              <Route path="/teacher/calendar" element={<TeacherLayout data-id="element-66">
                    <Calendar2 data-id="element-67" />
                  </TeacherLayout>} data-id="element-65" />
              <Route path="/teacher/calendar2" element={<TeacherLayout data-id="element-69">
                    <Calendar2 data-id="element-70" />
                  </TeacherLayout>} data-id="element-68" />
              {/* Public teacher profile routes - dynamic :id parameter */}
              <Route path="/teachers/:teacherId" element={<TeacherPublicProfilePage data-id="element-72" />} data-id="element-71" />
              <Route path="/revenue" element={<RevenuePage data-id="element-74" />} data-id="element-73" />
              <Route path="/assigned-tasks" element={<TeacherTasks data-id="element-76" />} data-id="element-75" />
              <Route path="/reports" element={<ReportsDashboard data-id="element-78" />} data-id="element-77" />
              <Route path="/payouts" element={<PayoutsInvoicesPage data-id="element-80" />} data-id="element-79" />
              <Route path="/complete-profile" element={<CompleteTeacherProfile data-id="element-82" />} data-id="element-81" />
              <Route path="/my-students" element={<MyStudents data-id="element-84" />} data-id="element-83" />
              <Route path="/student-data-check" element={<StudentDataCheck data-id="element-86" />} data-id="element-85" />
              <Route path="/teacher-messages" element={<TeacherLayout data-id="element-88">
                    <TeacherMessages data-id="element-89" />
                  </TeacherLayout>} data-id="element-87" />
              <Route path="/courses" element={<PublicCoursesPage data-id="element-91" />} data-id="element-90" />
              <Route path="/teacher/:id" element={<TeacherPublicProfilePage data-id="element-93" />} data-id="element-92" />
              <Route path="/public-profile/:teacherId" element={<TeacherPublicProfilePage data-id="element-95" />} data-id="element-94" />
              {/* Temporarily disabled student profile route
               <Route
               path="/student-profile/:studentId"
               element={<StudentProfilePage />}
               />
               */}
              <Route path="/student/lesson/:lessonId/join" element={<VirtualClassroom data-id="element-97" />} data-id="element-96" />
              <Route path="/student-grades/:studentId" element={<StudentGradesOverview data-id="element-99" />} data-id="element-98" />
              <Route path="/grades-management" element={<GradesManagementPage data-id="element-101" />} data-id="element-100" />
              {/* Teacher Sheet Music page - unchanged */}
              <Route path="/teacher-sheet-music" element={<SheetMusicPage data-id="element-103" />} data-id="element-102" />

              {/* Moonlight Sonata Viewer Page */}
              <Route path="/sheet-music/moonlight-sonata" element={<MoonlightSonataViewer data-id="element-105" />} data-id="element-104" />
              {/* Prelude in C Major Viewer Page */}
              <Route path="/sheet-music/prelude-in-c-major" element={<PreludeInCMajorViewer data-id="element-107" />} data-id="element-106" />
              {/* Generic Sheet Music Viewer for all other pieces */}
              <Route path="/sheet-music/view/:id" element={<GenericSheetMusicViewer data-id="element-109" />} data-id="element-108" />
              {/* New Routes for Student Registration Flow - unchanged */}
              <Route path="/instrument-selection" element={<InstrumentSelectionPage data-id="element-111" />} data-id="element-110" />
              <Route path="/teacher-matching" element={<TeacherMatchingPage data-id="element-113" />} data-id="element-112" />
              {/* Payment related routes */}
              <Route path="/payment-methods" element={<StudentLayout data-id="element-115">
                    <PaymentMethodsPage data-id="element-116" />
                  </StudentLayout>} data-id="element-114" />
              <Route path="/transaction-history" element={<StudentLayout data-id="element-118">
                    <TransactionHistoryPage data-id="element-119" />
                  </StudentLayout>} data-id="element-117" />
              <Route path="/subscription" element={<StudentLayout data-id="element-121">
                    <SubscriptionManagementPage data-id="element-122" />
                  </StudentLayout>} data-id="element-120" />
              {/* New Account Management Routes - PHASE 2 FIX: Use RoleAwareLayout to prevent layout mixing */}
              <Route path="/my-info" element={<RoleAwareLayout data-id="element-124">
                    <MyInfoPage data-id="element-125" />
                  </RoleAwareLayout>} data-id="element-123" />
              <Route path="/settings" element={<RoleAwareLayout data-id="element-127">
                    <SettingsPage data-id="element-128" />
                  </RoleAwareLayout>} data-id="element-126" />
              <Route path="/account-security" element={<RoleAwareLayout data-id="element-130">
                    <AccountSecurityPage data-id="element-131" />
                  </RoleAwareLayout>} data-id="element-129" />
              <Route path="/billing-payouts" element={<RoleAwareLayout data-id="element-133">
                    <BillingPayoutsPage data-id="element-134" />
                  </RoleAwareLayout>} data-id="element-132" />
              <Route path="/help-support" element={<RoleAwareLayout data-id="element-136">
                    <HelpSupportPage data-id="element-137" />
                  </RoleAwareLayout>} data-id="element-135" />
              <Route path="/about" element={<TeacherLayout data-id="element-139">
                    <AboutUsPage data-id="element-140" />
                  </TeacherLayout>} data-id="element-138" />
              <Route path="/careers" element={<CareersPage data-id="element-142" />} data-id="element-141" />
              <Route path="/knowledge-base/getting-started" element={<TeacherLayout data-id="element-144">
                    <KnowledgeBaseGettingStarted data-id="element-145" />
                  </TeacherLayout>} data-id="element-143" />
              <Route path="/knowledge-base/scheduling-lessons" element={<TeacherLayout data-id="element-147">
                    <KnowledgeBaseSchedulingLessons data-id="element-148" />
                  </TeacherLayout>} data-id="element-146" />
              <Route path="/knowledge-base/virtual-classroom" element={<TeacherLayout data-id="element-150">
                    <KnowledgeBaseVirtualClassroom data-id="element-151" />
                  </TeacherLayout>} data-id="element-149" />
              <Route path="/privacy-policy" element={<PrivacyPolicyPage data-id="element-153" />} data-id="element-152" />
              <Route path="/cookie-policy" element={<CookiePolicyPage data-id="element-155" />} data-id="element-154" />
              <Route path="/terms-of-service" element={<TermsOfServicePage data-id="element-157" />} data-id="element-156" />
            </Routes>
            {/* Single instance of SignInModal */}
            <SignInModal isOpen={isSignInModalOpen} onClose={closeSignInModal} data-id="element-158" />
            {/* Add ToastContainer */}
            <ToastContainer position="top-right" data-id="element-159" />
            {/* Add Toaster for react-hot-toast */}
            <Toaster position="top-center" toastOptions={{
            duration: 5000,
            style: {
              background: theme === 'dark' ? '#1A2A52' : '#ffffff',
              color: theme === 'dark' ? '#ffffff' : '#1f2937',
              minWidth: '300px',
              padding: '16px',
              fontSize: '14px'
            },
            success: {
              iconTheme: {
                primary: '#4ade80',
                secondary: 'white'
              },
              style: {
                background: theme === 'dark' ? '#1A2A52' : '#ffffff',
                border: theme === 'dark' ? '1px solid rgba(74, 222, 128, 0.3)' : '1px solid rgba(74, 222, 128, 0.2)'
              }
            }
          }} containerStyle={{
            top: 80,
            zIndex: 9999
          }} data-id="element-160" />
          </BrowserRouter>
          <style jsx global data-id="element-161">{`
            html {
              scroll-behavior: smooth;
            }
            /* Global CSS variables for dropdown styling */
            :root {
              --navy-700: #0a1128;
              --navy-800: #1a2a52;
              --navy-900: #0f1626;
              --deep-pink: #e63946;
              --dropdown-shadow:
                0 10px 15px -3px rgba(0, 0, 0, 0.1),
                0 4px 6px -2px rgba(0, 0, 0, 0.05);
            }
            /* Global select dropdown styling - use CSS variables for theming */
            select option {
              background-color: var(--dropdown-bg, #1f2937);
              color: var(--dropdown-text, white);
            }
            select option:checked {
              background-color: var(--dropdown-bg-selected, #394b6c);
              color: var(--dropdown-text-selected, white);
            }
            select option:hover {
              background-color: var(--dropdown-bg-hover, #2e3e5c);
            }
            select {
              background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 24 24' stroke='white'%3E%3Cpath stroke-linecap='round' stroke-linejoin='round' stroke-width='2' d='M19 9l-7 7-7-7'%3E%3C/path%3E%3C/svg%3E");
              background-position: right 0.5rem center;
              background-repeat: no-repeat;
              background-size: 1.5em 1.5em;
              padding-right: 2.5rem;
              -webkit-appearance: none;
              -moz-appearance: none;
              appearance: none;
              border-radius: 0.5rem;
            }
            select:focus {
              z-index: 10;
            }
            select::-ms-expand {
              display: none;
            }
            select option:checked,
            select option:focus,
            select option:active,
            select option:hover:checked {
              background-color: var(--dropdown-bg-selected, #394b6c) !important;
              color: var(--dropdown-text-selected, white) !important;
              box-shadow: 0 0 10px 100px var(--dropdown-bg-selected, #394b6c)
                inset !important;
              -webkit-text-fill-color: var(
                --dropdown-text-selected,
                white
              ) !important;
            }
            /* Dark mode styles for date and time inputs */
            input[type='date'],
            input[type='time'] {
              color-scheme: auto;
            }
            .bg-navy-900 input[type='date'],
            .bg-navy-900 input[type='time'],
            .bg-navy-800 input[type='date'],
            .bg-navy-800 input[type='time'] {
              color-scheme: dark;
            }
            /* Specific dark mode overrides for navy theme */
            .bg-navy-900 {
              background-color: #0a1128 !important;
            }
            .bg-navy-800 {
              background-color: #1a2a52 !important;
            }
            /* Calendar and time picker dropdown styling */
            .bg-navy-900::-webkit-calendar-picker-indicator,
            .bg-navy-800::-webkit-calendar-picker-indicator {
              filter: invert(1);
              background-color: transparent;
            }
            /* Time dropdown styling for dark mode */
            input[type='time']::-webkit-calendar-picker-indicator {
              background-color: transparent;
            }
            /* Dark mode time dropdown background */
            input[type='time']::-webkit-time-picker,
            input[type='time']::-webkit-datetime-edit,
            input[type='time']::-webkit-inner-spin-button,
            input[type='time']::-webkit-clear-button {
              color: white;
            }
            /* Style the time dropdown background in dark mode */
            .bg-navy-900 input[type='time']::-webkit-list-button,
            .bg-navy-800 input[type='time']::-webkit-list-button,
            .bg-navy-900 input[type='time']::-webkit-time-picker,
            .bg-navy-800 input[type='time']::-webkit-time-picker,
            .bg-navy-900
              input[type='time']::-webkit-datetime-edit-fields-wrapper,
            .bg-navy-800
              input[type='time']::-webkit-datetime-edit-fields-wrapper {
              background-color: rgba(
                26,
                42,
                82,
                0.5
              ); /* #1A2A52 with 50% opacity */
              color: white;
            }
            /* Weekend cells style for time dropdown */
            .bg-navy-900 input[type='time'].weekend::-webkit-time-picker,
            .bg-navy-800 input[type='time'].weekend::-webkit-time-picker {
              background-color: rgba(
                26,
                42,
                82,
                0.3
              ); /* #1A2A52 with 30% opacity */
            }
            /* Override browser default styles for the time dropdown in dark mode */
            @media (prefers-color-scheme: dark) {
              input[type='time']::-webkit-calendar-picker-dropdown {
                background-color: rgba(
                  26,
                  42,
                  82,
                  0.5
                ) !important; /* #1A2A52 with 50% opacity */
              }
            }
            /* Firefox specific styles for dark mode time picker */
            @-moz-document url-prefix() {
              .bg-navy-900 input[type='time'],
              .bg-navy-800 input[type='time'] {
                background-color: rgba(
                  26,
                  42,
                  82,
                  0.5
                ); /* #1A2A52 with 50% opacity */
                color: white;
              }
            }
            /* Light background override */
            .bg-white select option {
              background-color: white;
              color: #1f2937;
            }
            .bg-white select option:checked {
              background-color: #394b6c;
              color: white;
            }
            .bg-white select option:hover {
              background-color: #f3f4f6;
              color: #1f2937;
            }
            .bg-white select option:checked,
            .bg-white select option:focus,
            .bg-white select option:active,
            .bg-white select option:hover:checked {
              background-color: #394b6c !important;
              color: white !important;
              box-shadow: 0 0 10px 100px #394b6c inset !important;
            }
            /* Remove the hardcoded student dropdown styles that were overriding our theme variables */
            /* The styles below will be replaced by the component-level CSS in FindTeachers.tsx */
          `}</style>
        </div>
      </SignInModalContext.Provider>
    </AuthProvider>;
}
export function App() {
  return <ThemeProvider data-id="element-162">
      <AppContent data-id="element-163" />
    </ThemeProvider>;
}